import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=cd6e8e7e&scoped=true"
import script from "./order-add-or-update.vue?vue&type=script&lang=js"
export * from "./order-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./order-add-or-update.vue?vue&type=style&index=0&id=cd6e8e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6e8e7e",
  null
  
)

export default component.exports